import Header from "../../Questions/component/Header";
import style from "../css/ContactUs.module.css";
import contactBanner from "../../../icons/partner.png";
import { useEffect, useState } from "react";
import contact from "../../../icons/contactIcon.png";
import phoneIcon from "../../../icons/phoneIcon.png";
import {
  Mail,
  Store,
  ShoppingBag,
  Handshake,
  BottleWine,
  BadgePercent,
  TrendingUp,
  Ellipsis,
} from "lucide-react";

import { ErrorHandling } from "../../../State";
import UAParser from "ua-parser-js";
import { offerEvent } from "../../../utils/api";

function ContactUs() {
  const fanduPoints = localStorage.getItem("fanduPoints") || 0;

  let mId = localStorage.getItem("mId") || "2026";

  let uuid = localStorage.getItem("uuid");

  let session_id = localStorage.getItem("session_id");

  const offerRequestData = (eventMetaData) => {
    try {
      const parser = new UAParser();

      const result = parser.getResult();

      return {
        machine_id: mId || "",
        device_id: uuid || "",
        session_id: session_id || "",
        ip_address: localStorage.getItem("ip_address") || "",
        lat: "",
        lng: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        deviceBrand: result?.device?.vendor || "Unknown",
        deviceModel: result?.device?.model || "Unknown",
        deviceType: result?.device?.type || "desktop",
        osName: result?.os?.name || "Unknown",
        osVersion: result?.os?.version || "Unknown",
        browserName: result?.browser?.name || "Unknown",
        browserVersion: result?.browser?.version || "Unknown",
        event_ts: Date.now().toString(),
        user_id: localStorage.getItem("userId") || "",
        ...eventMetaData,
      };
    } catch (error) {
      ErrorHandling("Unable to collect device information");

      return null;
    }
  };

  const avail = async (EventName, EventSubName, EventType, EventSubType) => {
    try {
      const requestData = offerRequestData({
        Event_Name: EventName,
        Event_Sub_Name: EventSubName,
        Event_Type: EventType,
        Event_Sub_Type: EventSubType,
      });

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      console.log("Offer Event Error:", error);
    }
  };

  const options = [
    {
      id: "vendingMachine",
      label: "Place a Vending Machine",
      icon: <Store size={24} color="#3454ff" />,
    },
    {
      id: "sellProduct",
      label: "Sell your product with us",
      icon: <ShoppingBag size={24} color="#ff3b7f" />,
    },
    {
      id: "franchise",
      label: "Punnyadhara Franchise",
      icon: <Handshake size={24} color="#ff8400" />,
    },
    {
      id: "sampleProduct",
      label: "Sample your product with us",
      icon: <BottleWine size={24} color="#00a8b5" />,
    },
    {
      id: "brandMarketing",
      label: "Brand Marketing",
      icon: <BadgePercent size={24} color="#7a3cff" />,
    },
    {
      id: "partner",
      label: "Partner for Expansion",
      icon: <TrendingUp size={24} color="#ff4b4b" />,
    },
    {
      id: "others",
      label: "Others",
      icon: <Ellipsis size={24} color="#777" />,
    },
  ];

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    interest: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleInterest = (id) => {
    setFormData((prev) => ({
      ...prev,
      interest: id,
    }));
  };

  const handleSubmit = (e) => {
    console.log(formData);

    // axios.post("/api/contact", formData)
  };

  useEffect(() => {
    avail("Contact_Us_Screen", "Page_Open", "Screen_Impression", "list_view");
  });

  return (
    <>
      <Header fanduPoints={fanduPoints} />
      <img src={contactBanner} style={{ width: "100%" }} />
      <div className={style.bottomSection}>
        <p className={style.heading}>Let's Connect</p>
        <div className={style.contactForm}>
          <div className={style.nameText}>
            <img
              src={contact}
              style={{ width: "10px" }}
              className={style.icon}
            />
          </div>
          <input
            type="text"
            name="name"
            required
            value={formData.name}
            maxLength={30}
            placeholder="Enter your Full Name.."
            onChange={handleChange}
          />
          <div className={style.nameText}>
            <img
              src={phoneIcon}
              style={{ width: "13px" }}
              className={style.icon}
            />
          </div>
          <input
            type="text"
            value={formData.phone}
            name="phone"
            maxLength={10}
            placeholder="Enter your Phone Number.."
            onChange={handleChange}
            inputMode="numeric"
            pattern="[0-9]*"
          />
          <div className={style.nameText}>
            {/* <img
              src={phoneIcon}
              style={{ width: "13px" }}
              className={style.icon}
            /> */}
            <Mail size={14} color="#3550dc" className={style.icon} />
          </div>
          <input
            type="text"
            name="email"
            value={formData.email}
            maxLength={10}
            placeholder="Enter your Email.."
            onChange={handleChange}
          />

          <div className={style.heading2}>
            <p>Please choose an option</p>
            <span>I'm interested in</span>
          </div>

          {options.map((item) => (
            <label className={style.optionCard} key={item.id}>
              <div className={style.left}>
                {item.icon}
                <span>{item.label}</span>
              </div>

              <input
                type="radio"
                name="interest"
                checked={formData.interest === item.id}
                onChange={() => handleInterest(item.id)}
              />
            </label>
          ))}

          <button
            type="button"
            className={style.submitBtn}
            onClick={() => {
              avail(
                "Contact_Us_Submit",
                "Contact_Us_Screen",
                "Click",
                "Screen_Impression",
              );
              handleSubmit();
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
